import React, { FC } from 'react';
import { Field, Form, Formik, FieldProps, FormikHelpers } from 'formik';

import { ConfirmBirthdateData } from 'types';
import { birthdateRegexp, composeValidators, pattern, required } from 'utils/validate';
import { PatternFormat } from 'react-number-format';
import formStyles from 'pages/Login/components/LoginForm/LoginForm.module.scss';
import entryStyles from 'layouts/AuthEntryLayout/AuthEntryLayout.module.scss';
import { MAX_ATTEMPTS_REACHED } from 'constants/errors';

interface FormData extends Pick<ConfirmBirthdateData, 'birthdate'> {}
interface Props {
  onSubmit: (values: FormData) => Promise<any>;
  onCancel: () => void;
}

export const BirthdateForm: FC<Props> = ({ onSubmit, onCancel }) => {
  const handleSubmit = async ({ birthdate }: FormData, { setFieldError }: FormikHelpers<FormData>) => {
    try {
      await onSubmit({ birthdate });
    } catch (e: any) {
      if (e?.data?.message === 'max_attempts_reached') {
        setFieldError('birthdate', MAX_ATTEMPTS_REACHED);
      } else {
        setFieldError('birthdate', 'Неверная дата рождения');
      }
    }
  };

  return (
    <Formik
      initialValues={{
        birthdate: '',
      }}
      validateOnMount
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid }) => (
        <Form className={formStyles.form} noValidate>
          <Field name="birthdate" validate={composeValidators([required(), pattern(birthdateRegexp)])}>
            {({ field, meta, form }: FieldProps) => {
              const error = meta.touched && meta.error;
              return (
                <div className={formStyles.field}>
                  <label htmlFor="recovery-birthdate">Введите свою дату рождения<span className={formStyles.required}>*</span></label>
                  <PatternFormat
                    id="recovery-birthdate"
                    name={field.name}
                    value={field.value}
                    onBlur={field.onBlur}
                    onValueChange={({ value }) => form.setFieldValue(field.name, value)}
                    valueIsNumericString
                    format="##.##.####"
                    mask="_"
                    allowEmptyFormatting
                    inputMode="numeric"
                    placeholder="ДД.ММ.ГГГГ"
                    autoComplete="bday"
                    autoFocus
                    required
                    className={formStyles.input}
                    aria-invalid={!!error}
                    aria-describedby="recovery-birthdate-error"
                  />
                  <div id="recovery-birthdate-error" className={formStyles.error} aria-live="polite">{error || ' '}</div>
                </div>
              );
            }}
          </Field>
          <button className={formStyles.submitBtn} type="submit" disabled={!isValid || isSubmitting} aria-busy={isSubmitting}>
            {isSubmitting ? 'Проверяем…' : 'Далее'}
          </button>
          <button className={entryStyles.back} type="button" onClick={onCancel}>Отмена</button>
        </Form>
      )}
    </Formik>
  );
};
